<template>
  <div class="feature-summary" :class="[color ? color : '']">
    <img class="feature-image" v-lazy="imagePath" :alt="altText" />
    <div class="summary-body">
      <h2>{{ headerText }}</h2>
      <p>{{ detailText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['imagePath', 'altText', 'headerText', 'detailText', 'color'],
}
</script>

<style scoped>
.feature-image {
  display: block;

  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.summary-body {
  margin: 20px 0;

  white-space: pre-line;
}

.summary-body h2 {
  line-height: 36px;
  font-size: 2em;
  margin: 0 0 10px;
}

.green .summary-body h2 {
  color: rgb(45, 183, 68);
}

.blue .summary-body h2 {
  color: rgb(16, 104, 199);
}

.summary-body p {
  font-size: 14px;
  line-height: 26px;

  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ProductFeatureSummary.vue